module.exports = __webpack_public_path__ + "img/RORBPJR23052.7b33d450.png";